import React, {useEffect, useState} from 'react';
import Header from './Header';
import { Card, Button } from  'react-bootstrap';
import firebase from 'firebase/app';
import { Link } from 'react-router-dom';
// import firebaseIntances from "../firebaseConfig";
import 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import musicThumbnail from '../assets/images/group_concert.png';
import foodImage from '../assets/images/daytime_dinner_party.png';
import jamaicaEvent from '../assets/images/Jamaica61_event.jpg';
import internationalTravel from '../assets/images/group_mural2.png'
import TourBooking from './Tours';
import Community from  '../pages/Community';



// const { db } = firebaseIntances;
function Events() {
  //Connect to firebase
  // useEffect(() => {
  //   const db = db.firestore();
  //   db.collection('events')
  //     .orderBy('date', 'asc')
  //     .get()
  //     .then((querySnapshot) => {
  // //       const data = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
  // //       setEvents(data);
  // //     })
  // //     .catch((error) => {
  // //       console.log('Error getting events: ', error);
  // //     });
  // // }, []);

  // // const handleSearchChange = (event) => {
  // //   setSearchTerm(event.target.value);
  // // };

  // const filteredEvents = events.filter((event) => {
  //   return (
  //     event.category.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     event.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     event.title.toLowerCase().includes(searchTerm.toLowerCase())
  //   );
  // });
  document.title = 'Unieros Multicultural Events';

    return (
      
      <section class="py-5 text-center container">   
        <div class="row py-lg-5">
          <div class="col-lg-6 col-md-8 mx-auto">
          <h1 class="display-1 page-title">Events</h1>
            <p class="lead text-body-secondary">
              <p>Explore and connect with different cultures through Unieros events.
                From food tours to music festivals, you'll love the immersive and welcoming atmosphere.
              </p>
            </p>
            <p className="mb-2">
              {/* <a href="#" class="btn btn-unieros my-2">Sign up</a> */}
            </p>
          </div>
        </div>
     
      
      <div className="container my-5">
      <div className="row mt-4">
       
      <h2>Latest event</h2>
        <div className="col-sm-12 mb-4">
          <Card className="newsletter-signup">
            <Card.Img variant="top" src={jamaicaEvent} />
            <Card.Body>
              <Card.Title >Tings A Gwaan: Celebration of Jamaican & Caribbean Culture</Card.Title>
              <Card.Text>
                
              </Card.Text>
              <Link to={`/post/event-review-tings-a-gwaan-a-celebration-of-jamaican-caribbean-culture`} className="btn btn-unieros">View photos</Link>
            
            </Card.Body>
          </Card>
        </div>
      </div>
{/* /      <div className="row mt-4">
      <h2>Upcoming events</h2>
        <div className="col-sm-12 mb-4">
          <Card className="event-list"> 
            <Card.Body>
              <Card.Title className="peach"> <i class="bi bi-music-note-beamed"></i> Music & Art Events</Card.Title>  
              <Card.Text>
                Immerse yourself in a world of music and art with our upcoming events.
              </Card.Text>
              <Link to="/eventlist" className="btn btn-unieros">View Events</Link>
            </Card.Body>
          </Card>
        </div>
</div> */}


      <div className="row mt-4">
      <h2>Tours</h2>
      <div className="col-sm-12 mb-8">

          <Card>
           <Card.Img variant="top" src={internationalTravel} />
            <Card.Body>
            <Card.Title className='peach'><i class="bi bi-airplane-engines"></i>Travel</Card.Title>
            <Community />
            <TourBooking />
            <section className="col-sm-12 mb-8">
            <div className="accordion " id="tourAccordion">
  <div className="accordion-item">
    <h2 className="accordion-header">
      <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
        <p className="lead">Day 1: Welcome to Kingston</p>
      </button>
    </h2>
    <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#tourAccordion">
      <div className="accordion-body">
      <p className="lead">Morning:</p>
                    <p>Breakfast: Relish traditional Jamaican breakfast dishes, particularly the famous ackee and saltfish.</p>
                 
                    <p className="lead">Afternoon:</p>
                    <p>Bob Marley Museum: Start your journey with a visit to this museum located at the former home of the reggae legend. It offers an insightful look into his life and the evolution of reggae music. </p>
                    <p className="lead">Evening:</p>
                    <p>Dance the Night Away: Visit a local dancehall or reggae bar. Kingston has several of them with live bands or DJs spinning the latest hits. </p>
      </div>
    </div>
  </div>
  <div className="accordion-item">
    <h2 class="accordion-header">
      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
      <p className="lead">Day 2: Kingston’s Art & Music</p>
      </button>
    </h2>
    <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#tourAccordion">
      <div className="accordion-body">
    
                    <p class="lead">Morning:</p>
                    <p>National Gallery of Jamaica: Immerse yourself in Jamaican art, spanning from the Taino times to contemporary pieces. </p>
                    
                    <p class="lead">Afternoon:</p>
                    <p>Devon House: Dine at the Grog Shoppe and treat yourself to some of the best ice cream on the island at the famous Devon House I-Scream. </p>
                    
                    <p class="lead">Evening:</p>
                    <p>Dinner at The Marketplace: This culinary hub offers a variety of restaurants. Try “Tracks and Records” for a mix of music and Jamaican fusion dishes </p>

                    
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header">
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
      <p className="lead green">Day 3: Modern Beats & Street Arts</p>
      </button>
    </h2>
    <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#tourAccordion">
      <div class="accordion-body">
      
       
                    <p class="lead">Morning:</p>
                    <p>Street Art Tour: Start with a walking tour in Kingston, known for its vivid murals and community-driven art initiatives.
</p>
                    
                    <p class="lead">Afternoon:</p>
                    <p>Ital food: Enjoy a Rasta vegan lunch in authentic local restaurant where you will experience the Rastfarian culture that originated in Jamaica. </p>
                    
                    <p class="lead">Evening:</p>
                    <p>Dub Music: Nestled in the hills overlooking Kingston, this spot offers reggae rhythms in a serene, natural setting. Dance to dub beats or just relax and soak in the vibes.
 </p>
    </div>
   
  </div>
</div>
</div>
</section>
<section className="tourAmeneties">

<div className="whats-included">
    <h6 className="lead">What's Included</h6>
    <ul>
        <li>2 lunches</li>
        <li>3 dinners</li>
        <li>Roundtrip transportation to and from Kingston airport</li>
        <li>Transportation to daily activities</li>
        <li>Bottled water</li>
        <li>Museum entry fees</li>
        <li>Local guide along the way</li>
    </ul>
</div>
<div className="whats-excluded">
    <h6 className="lead"> What's Excluded</h6>
    <p>We have recommendations for the following items but they are not included in package.</p>
    <ul>
        <li>Lodging</li>
        <li>Airfare</li>
        <li>Tips</li>
    </ul>
    </div>
    <p className="small">Note: Ensure you wear comfortable shoes, as there's a lot of walking. We will provide bottles of water. Remember to bring open mind to immerse yourself in the culture. Jamaicans are friendly and always ready to share stories of their vibrant city.</p>
 
</section>
<h5>Want to learn more about this tour?</h5>

              <a href="https://calendly.com/unieros/kingston-travel-tips" variant="primary" className="btn btn-unieros">Book Tour Info Session </a>
            </Card.Body>
          </Card>
        </div>
        {/* <div className="col-sm-4 mb-4">
          <Card>
          <Card.Img variant="top" src={musicThumbnail} />
            <Card.Body>
              <Card.Title className="peach"> <i class="bi bi-music-note-beamed"></i> Music & Art Events</Card.Title>
              <Card.Text>
                Immerse yourself in a world of music and art with our upcoming events.
              </Card.Text>
              <Link to="/afrohall" className="btn btn-custom-primary">View Events</Link>
            </Card.Body>
          </Card>
        </div>
        <div className="col-sm-4 mb-4">
          <Card>
            <Card.Img variant="top" src={foodImage} />
            <Card.Body>
              <Card.Title className="peach"><i class="bi bi-cup-straw"></i>Food & Drinks</Card.Title>
              <Card.Text>
                Try new flavors and explore different cultures with our upcoming food events.
              </Card.Text>
              <Button variant="primary" className="btn btn-custom-primary">View Events</Button>
            </Card.Body>
          </Card>
        </div> */}
       
        <div>
         
        </div>
      </div>
     
    </div>

    </section>
    );
  }

  export default Events;